import { render, staticRenderFns } from "./ArenaRoom.vue?vue&type=template&id=51b8a3ca&scoped=true&"
import script from "./ArenaRoom.vue?vue&type=script&lang=js&"
export * from "./ArenaRoom.vue?vue&type=script&lang=js&"
import style0 from "./ArenaRoom.vue?vue&type=style&index=0&id=51b8a3ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8a3ca",
  null
  
)

export default component.exports